<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 md8 lg6>
      <v-card class="elevation-12" v-if="reg" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Exhibit Hall Registration</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 class="subheading mx-4 text-xs-center">
                Thank you for registering. You will be recieving a confirmation email shortly.
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>

      <v-card class="elevation-12" v-else-if="hash" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Exhibit Hall Registration</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  Please enter a logo, a booth image and a product image.
                </v-flex>
                <v-flex xs12>
                    <span v-if="logo">Logo Added!</span>
                  <v-btn v-else color="primary" @click="newLogo('logo')">Add Logo</v-btn>
                </v-flex>
                <v-flex xs12>
                  <span v-if="booth">Booth Added!</span>
                  <v-btn v-else color="primary" @click="newLogo('booth')">Add Booth</v-btn>
                </v-flex>
                <v-flex xs12>
                  <span v-if="product">Product Added!</span>
                  <v-btn v-else color="primary" @click="newLogo('product')">Add Product</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          <v-alert :value="error" type="warning" transition="scale-transition">
            <span v-html="error"></span>
          </v-alert>

        <div class="subheading mx-4 text-xs-center">
          <p>
            Once submitted, you will receive a confirmation email.<br />
            <strong>NO DEPOSIT WITH APPLICATION!</strong>
          </p>
        </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="register">Submit</v-btn>
        </v-card-actions>
      </v-form>
      </v-card>

      <v-card class="elevation-12" v-else align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Exhibit Hall Registration</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.name"
                    label="Company"
                    ref="focusName"
                    :rules="[v => !!v || 'Company is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.address"
                    label="Address"
                    :rules="[v => !!v || 'Address is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.city"
                        label="City"
                        :rules="[v => !!v || 'City is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3>
                      <v-text-field
                        v-model="editedItem.state"
                        label="State/Province"
                        :rules="[v => !!v || 'State/Province is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3>
                      <v-text-field
                        v-model="editedItem.zip"
                        label="Postal Code"
                        :rules="[v => !!v || 'Postal Code is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.phone"
                        label="Phone"
                        :rules="[v => !!v || 'Phone is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.country"
                        label="Country"
                        :rules="[v => !!v || 'Country is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.webSite"
                    label="Website"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="editedItem.profile"
                    label="Company Profile"
                    prepend-icon="notes"
                    :rules="[v => !!v || 'Company Profile is required']"
                    required
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="editedItem.product"
                    label="Product Description"
                    prepend-icon="notes"
                    :rules="[v => !!v || 'Product Description is required']"
                    required
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.size"
                    label="Booth Size"
                    :rules="[v => !!v || 'Booth Size is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.power"
                    label="Power Requirement"
                    :rules="[v => !!v || 'Power Requirement is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">PRIMARY CONTACT</span>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.firstName"
                    @keyup.enter="save"
                    label="First Name"
                    :rules="[v => !!v || 'First Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.lastName"
                    @keyup.enter="save"
                    label="Last Name"
                    :rules="[v => !!v || 'Last Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="editedItem.contactPhone"
                    label="Phone"
                    prepend-icon="phone"
                    :rules="[v => !!v || 'Phone is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.title"
                    label="Title"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="editedItem.mobile"
                    label="Mobile"
                    prepend-icon="stay_current_portrait"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="email"
                    label="Email"
                    type="email"
                    v-model="editedItem.email"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          <v-alert :value="error" type="warning" transition="scale-transition">
            <span v-html="error"></span>
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">Next</v-btn>
        </v-card-actions>
      </v-form>
      </v-card>
    </v-flex>

    <v-dialog
      v-model="logoDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Logo</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-text-field
                  label="Select..."
                  @click='onPickFile'
                  v-model='fileName'
                  prepend-icon="attach_file"
                ></v-text-field>
                <!-- Hidden -->
                <input
                  type="file"
                  style="display: none"
                  ref="logoInput"
                  accept="*/*"
                  @change="onFilePicked">
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveImage">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import moment from 'moment'

export default {
  data () {
    return {
      logo: false,
      booth: false,
      product: false,
      reg: false,
      logoDialog: false,
      boothDialog: false,
      productDialog: false,
      valid: true,
      currentYear: 0,
      checkbox: false,
      body: {},
      hash: '',
      type: '',
      fileName: '',
      files: [],
      editedItem: {
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      error: null,
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
    this.getDate()
    this.getHash()
  },

  methods: {
    getDate () {
      let currentYear = moment().format('YYYY')
      let nextYear = moment()
        .add(1, 'years')
        .format('YYYY')
      let currentDate = moment().format('MM')

      if (currentDate >= 7) {
        this.currentYear = nextYear
      } else {
        this.currentYear = currentYear
      }
    },

    async getHash () {
      this.hash = new URL(location.href).searchParams.get('key')
      this.body.hash = this.hash

      if (this.hash) {
        try {
          const response = await Api().get('get_vendor_hash/' + this.hash)
          console.log(response.data)
          this.body = response.data
          this.body.email = this.body.VendorContacts[0].email
          this.body.fileName = ''
        } catch (error) {
          this.snackbar.message = 'Could not retreive your registration!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    newLogo (type) {
      this.logoDialog = true
      this.type = type
    },

    onPickFile () {
      this.$refs.logoInput.click()
    },

    onFilePicked (event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        console.log(files[0])
        this.body.fileName = files[0].name
        this.fileName = files[0].name
        // Check validity of file
        if (this.body.fileName.lastIndexOf('.') <= 0) {
          return
        }
        // If valid, continue
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.url = fr.result
          this.fileObject = files[0] // this is an file that can be sent to server...
        })
      } else {
        this.body.fileName = ''
        this.fileObject = null
        this.url = ''
      }
    },

    async save () {
      try {
        this.editedItem.year = this.currentYear
        this.editedItem.new = 'Yes'

        console.log(this.editedItem)

        if (this.$refs.form.validate()) {
          const response = await Api().post('vendor_registration', this.editedItem)
          console.log(response.data)
          this.body = response.data.body
          this.hash = this.body.hash

          this.snackbar.message = 'First step complete!'
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    saveImage () {
      if (this.type === 'logo') {
        this.saveLogo()
      } else {
        this.savePics()
      }
    },

    async saveLogo () {
      let filenames = []

      let formData = new FormData()
      formData.append('name', this.body.name)
      formData.append('year', this.currentYear)
      formData.append('fileName', this.body.fileName)
      formData.append('id', this.body.id)

      for (var i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i])
        filenames.push(this.files[i].name)
      }

      formData.append('files', this.fileObject)

      try {
        const response = await Api().post('vendor_rlogo', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

        this.documents = []
        this.logoDialog = false
        this.logo = true

        this.fileName = ''
        this.body.fileName = ''
        this.fileObject = null
        this.url = ''

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async savePics () {
      let filenames = []

      let formData = new FormData()
      formData.append('name', this.body.name)
      formData.append('year', this.currentYear)
      formData.append('fileName', this.body.fileName)
      formData.append('UserId', 79)
      formData.append('VendorCompanyId', this.body.id)

      for (var i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i])
        filenames.push(this.files[i].name)
      }

      formData.append('files', this.fileObject)

      try {
        const response = await Api().post('vendor_rfiles', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

        this.documents = []
        this.logoDialog = false

        this.fileName = ''
        this.body.fileName = ''
        this.fileObject = null
        this.url = ''

        if (this.type === 'booth') {
          this.booth = true
        } else {
          this.product = true
        }

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async register () {
      try {
        // this.editedItem.new = 'Yes'
        // this.editedItem.hash = this.hash

        // console.log(this.editedItem)

        if (this.logo && this.booth && this.product) {
          const response = await Api().post('vendor_registration', this.body)
          console.log(response.data)
          this.reg = true

          this.snackbar.message = 'Congratulation, your registration has been submitted!'
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } else {
          this.snackbar.message = 'You must enter a logo, a booth image and a product image!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    close () {
      this.logoDialog = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/vendor/ExternalForm.vue